'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusDuty = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _api = require('plugins/api');

var _api2 = _interopRequireDefault(_api);

var _iview = require('iview');

var _iview2 = _interopRequireDefault(_iview);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dutyChain = _api2.default.dutyChain,
    cookies = _api2.default.cookies;

var status200 = function status200(type) {
  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var filterFreeRequests = _store2.default.state.filterFreeRequests;
  if (type !== 200) return 'next';
  var config = res.config;

  var method = config.method.toUpperCase();
  //考虑到浏览器刷新，必须存储到localStorage
  var configUrl = '';
  if (config.url.indexOf('../api/') >= 0) {
    configUrl = config.url.split('../api/')[1];
  } else if (config.url.indexOf('../') >= 0) {
    configUrl = config.url.split('../')[1];
  } else {
    configUrl = config.url;
  }
  //console.log(configUrl)
  if (method === 'GET' && filterFreeRequests.indexOf(configUrl) < 0) {
    //获取cookie,进行设置
    localStorage.setItem('token', cookies.get('XSRF-TOKEN'));
  }
  if (res.data && res.data.code && res.data.code != '2000') {
    switch (res.data.code) {
      case '10003':
        //重复提交
        res.data.message = '请勿重复提交';
        break;
      case '5000':
        //服务端异常
        break;
    }
    //阻止错误信息提示
    if (config.preventMessage) {
      return res;
    }
    _iview2.default.Message.error(res.data.message);
    return _promise2.default.reject(res.data.message);
  }
  return res;
};
//创建职责链
var statusDuty = dutyChain(status200);
//定义职责链
exports.statusDuty = statusDuty;